import React, { Component } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faHourglass, faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Select from 'react-select';
import { connect } from 'react-redux';
import Flatpickr from 'react-flatpickr';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { GET, POST } from '../../api';
import { toast } from 'react-toastify';
import { handleFormErrors } from '../../helpers/form_helpers';
import SweetAlert from 'react-bootstrap-sweetalert';

const apiURL = process.env.REACT_APP_API_URL;

class LeadTasks extends Component {

  deleteConfirm = {
    show: false,
    id: 0,
    action: () => { }
  }

  taskFields = {
    ls_id: null,
    noenrolment_id: null,
    no_reg_reason: '',
    task_duedate: moment().format('YYYY-MM-DD'),
    task_reminder_date: this.calculateTaskDate(),
    task_desc1: '',
    task_desc2: '',
    attachment1: '',
    attachment2: '',
    attachment3: '',
  };

  state = {
    leadStatusList: [],
    tasksModal: {
      show: false,
      fetching: false,
      data: [],
      id: 0,
      waitingObject: null
    },
    deleteConfirm: this.deleteConfirm,
    ...this.taskFields,
  };

  calculateTaskDate() {
    const { centerData } = this.props.authData;
    const { weekend_days } = centerData;
    let weekendDays = weekend_days.split(',');

    let weekdays = {
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
      sunday: 7
    };

    weekendDays = weekendDays.map((day) => weekdays[day.toLowerCase()]);

    let date = moment();
    let daysAdded = 0;

    while (daysAdded < 3) {
      date.add(1, 'day');
      if (!weekendDays.includes(date.isoWeekday())) {
        daysAdded++;
      }
    }

    return date.format('YYYY-MM-DD');
  }

  componentDidMount() {
    this.getLeadStatus();
  }

  componentDidUpdate(prevProps) {
    // console.log('this.props.waitingObject', this.props.waitingObject);
    if (this.props.waitingObject?.waiting_id !== prevProps.waitingObject?.waiting_id) {
      if (this.props.waitingObject) {
        this.getTasksList(this.props.waitingObject);
      } else {
        this.setState({
          tasksModal: {
            ...this.state.tasksModal,
            show: false,
            data: [],
          },
        });
      }
    }
  }

  getLeadStatus = async () => {
    try {
      const response = await GET('waiting/get-lead-status');

      // Lead Status
      const leadStatusList = response.data.map((item) => {
        return {
          ...item,
          value: item.ls_id,
          label: item.ls_abbreviation,
        };
      });

      this.setState({
        leadStatusList,
      });
    } catch (err) {
      console.log('err', err);
    }
  };

  handleCloseTasksModal = () => {
    this.setState({
      tasksModal: {
        fetching: false,
        data: [],
        id: 0,
        waitingObject: null,
      },
      ...this.taskFields,
    });
    this.props.onHide();
  }

  taskAttachmentHandler = (event) => {
    let id = event.target.id;
    let file_size = event.target.files[0].size;
    let file_type = event.target.files[0].type;
    let allowedTypes = [
      'image/jpeg',
      'image/gif',
      'image/png',
      'application/pdf',
    ];

    if (file_size > 2097152) {
      toast.error(t('Attachment allowed size in 2MB max!'));
      event.target.value = '';
      return;
    }

    if (!allowedTypes.includes(file_type)) {
      toast.error(t('Only image or pdf file is allowed!'));
      event.target.value = '';
      return;
    }

    this.setState({ [id]: event.target.files[0] });
  };

  getTasksList = async (waitingObject) => {
    this.setState({
      tasksModal: {
        ...this.state.tasksModal,
        fetching: true,
      },
    });

    try {
      const res = await GET('waiting/get-tasks', {
        params: {
          waiting_id: waitingObject.waiting_id,
          limit: -1,
          offset: 0,
        },
      });

      this.setState({
        tasksModal: {
          ...this.state.tasksModal,
          fetching: false,
          data: res.data.data,
          waitingObject,
          show: true,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  getCenterEmailTemplate = async (ls_id) => {
    try {
      const res = await GET('waiting/get-center-email-template', {
        params: {
          waiting_id: this.state.tasksModal.waitingObject.waiting_id,
          ls_id,
        },
      });


      this.setState({
        task_desc2: res.data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  saveWaitingTask = async () => {
    const { authData } = this.props;
    const { registration_form_url, email1 } = authData.centerData;

    this.setState({ working: true });

    const {
      ls_id,
      task_duedate,
      task_reminder_date,
      task_desc1,
      task_desc2,
      tasksModal,
      attachment1,
      attachment2,
      attachment3,
      noenrolment_id,
      no_reg_reason,
    } = this.state;

    try {
      const fData = new FormData();

      fData.append(
        'waitingTaskData',
        JSON.stringify({
          ls_id: ls_id.value,
          task_duedate,
          task_reminder_date,
          task_desc1,
          task_desc2,
          waiting_id: tasksModal.waitingObject.waiting_id,
          registration_form_url,
          email1,
          noenrolment_id: noenrolment_id?.value,
          no_reg_reason,
        })
      );

      if (attachment1) {
        fData.append('attachment1', attachment1);
      }

      if (attachment2) {
        fData.append('attachment2', attachment2);
      }

      if (attachment3) {
        fData.append('attachment3', attachment3);
      }

      const res = await POST('waiting/insert-waiting-task', fData);

      if (res.data.type) {
        this.setState({
          working: false,
          ...this.taskFields
        });
        toast.success(t(res.data.message));
        this.props.fetch();
        this.getTasksList(tasksModal.waitingObject);
      } else {
        if (res.data.messageType == 'custom_error') {
          toast.error(t(res.data.message));
        } else {
          handleFormErrors(res.data.data);
        }
        this.setState({ working: false });
      }
    } catch (err) {
      console.log('err', err);

      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  };

  deleteTask = async () => {
    try {
      const res = await GET('waiting/delete-waiting-task', {
        params: {
          task_id: this.state.deleteConfirm.id,
        },
      });
      this.setState({
        tasksModal: {
          ...this.state.tasksModal,
          data: this.state.tasksModal.data.filter(
            (item) => item.task_id !== this.state.deleteConfirm.id
          ),
        },
        deleteConfirm: {
          show: false,
          id: 0,
          action: () => { },
        },
      });
      toast.success(t(res.data.message));
      this.props.fetch();
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  };

  render() {

    const { auth_key } = this.props.authData;

    let leadStatus = [];
    leadStatus = this.state.leadStatusList.filter((item) => item.admission_status_id != 1);
    if (this.state.tasksModal.waitingObject?.admission_id) {
      leadStatus = leadStatus.filter((item) => [7, 12].includes(item.admission_status_id));
    }
    // else {
    //   leadStatus = leadStatus.filter((item) => item.admission_status_id != 12);
    // }

    return (
      <>
        <Modal
          size='xxl'
          backdrop='static'
          keyboard={false}
          show={this.state.tasksModal.show}
          onHide={this.handleCloseTasksModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Tasks')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='p-0'>
            <Row>
              <Col md="6" className='pe-0'>
                <div className='grey-section' style={{ padding: 10, borderRadius: 0, height: '100%', borderBottomLeftRadius: 10 }}>
                  {this.state.tasksModal.data.length > 0 && this.state.tasksModal.data.map((item, index) => {

                    return <div key={index}
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: 5,
                        padding: 10,
                        marginBottom: this.state.tasksModal.data.length === index + 1 ? 0 : 10,
                      }}>
                      <Row className='mb-2'>
                        <Col>
                          <span style={{
                            display: 'inline-block',
                            backgroundColor: item.ls_color,
                            color: '#fff',
                            padding: '2px 5px',
                            borderRadius: 5,
                            fontSize: 14,
                            fontWeight: 'bold',
                            marginRight: 10
                          }}>{item.ls_abbreviation}</span>
                          {item.task_duedate &&
                            <span style={{
                              display: 'inline-block',
                              backgroundColor: '#f2f2f2',
                              color: '#000',
                              padding: '2px 5px',
                              borderRadius: 5,
                              fontSize: 14,
                            }}
                            ><FontAwesomeIcon icon={faCalendarAlt} className='me-1' />{moment(item.task_duedate).format('DD-MM-YYYY')}</span>
                          }
                        </Col>
                        <Col className='text-end'>
                          {item.task_reminder_date &&
                            <span style={{
                              display: 'inline-block',
                              backgroundColor: '#f2f2f2',
                              color: '#000',
                              padding: '2px 5px',
                              borderRadius: 5,
                              fontSize: 14,
                            }}
                            ><FontAwesomeIcon icon={faHourglass} className='me-1' />{moment(item.task_reminder_date).format('DD-MM-YYYY')}</span>
                          }
                          {item.admission_status_id != 1 && (
                            <button
                              title='Delete'
                              onClick={() => this.setState({
                                deleteConfirm: {
                                  show: true,
                                  id: item.task_id,
                                  action: this.deleteTask
                                }
                              })}
                              variant='danger'
                              style={{
                                background: '#D23341',
                                fontSize: 14,
                                color: '#fff',
                                border: 0,
                                borderRadius: 5,
                                padding: '2px 8px',
                                marginLeft: 10
                              }}>
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>{item.task_desc1}</Col>
                      </Row>
                    </div>
                  }
                  )}
                  {this.state.tasksModal.data.length === 0 && (
                    <div className='text-center'>{t('No Task Found!')}</div>
                  )}
                </div>
              </Col>
              <Col md="6" className='py-3 pe-4 ps-3'>
                <Row>
                  <Col md={6}><strong>{t('Parent Name:')}</strong> {this.state.tasksModal.waitingObject?.parent_name}</Col>
                  <Col md={6}><strong>{t('Student Name:')}</strong> {this.state.tasksModal.waitingObject?.child_name}</Col>
                  <Col md={6}><strong>{t('Email:')}</strong> {this.state.tasksModal.waitingObject?.email1}</Col>
                  <Col md={6}><strong>{t('Phone:')}</strong> {this.state.tasksModal.waitingObject?.phone1}</Col>
                </Row>
                <hr />
                <div className='mb-2'><strong>{t('Add Task')}</strong></div>
                <Row>
                  <Col md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>
                        {t('Lead Status')} <span className='text-danger'>*</span>
                      </Form.Label>
                      <Select
                        value={this.state.ls_id}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={leadStatus}
                        onChange={(obj) => {
                          this.setState({ ls_id: obj });
                          this.getCenterEmailTemplate(obj.value);
                        }}
                        formatOptionLabel={({ ls_color, ls_abbreviation }) => (
                          <span
                            style={{
                              borderColor: ls_color,
                              borderWidth: 2,
                              borderStyle: 'solid',
                              color: ls_color,
                              padding: 1,
                              fontSize: 13,
                              borderRadius: 5,
                              paddingInline: 7,
                            }}>
                            {ls_abbreviation}
                          </span>
                        )}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Date')}</Form.Label>
                      <Flatpickr
                        options={{
                          static: true,
                        }}
                        className='form-control'
                        value={this.state.task_duedate}
                        onChange={([date]) => {
                          this.setState({
                            task_duedate: moment(date).format('YYYY-MM-DD'),
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Set Reminder Date')}</Form.Label>
                      <Flatpickr
                        options={{
                          static: true,
                        }}
                        className='form-control'
                        id="task-reminder-date"
                        value={this.state.task_reminder_date}
                        onChange={([date]) => {
                          this.setState({
                            task_reminder_date: moment(date).format('YYYY-MM-DD'),
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  {(this.state.ls_id?.admission_status_id == 12) && (
                    <>
                      <Col md={12}>
                        <Alert variant={'warning'}>
                          {t('This lead status will close the lead automatically!')}
                        </Alert>
                      </Col>
                    </>
                  )}
                  {this.state.ls_id?.admission_status_id == 12 && (
                    <>
                      <Col md={6}>
                        <Form.Group className='mb-3'>
                          <Form.Label style={{ height: 17 }}>
                            {t('Reason')}
                          </Form.Label>
                          <Select
                            value={this.state.noenrolment_id}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                            options={this.props.noEnrReasons}
                            onChange={(obj) => {
                              this.setState({ noenrolment_id: obj });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className='mb-3'>
                          <Form.Label>{t('Reason Explanation')}</Form.Label>
                          <Form.Control
                            defaultValue={this.state.no_reg_reason}
                            onChange={(e) =>
                              this.setState({ no_reg_reason: e.target.value })
                            }
                            as='textarea'
                            rows={3}
                          />
                        </Form.Group>
                      </Col>
                    </>
                  )}
                  <Col md={12}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Admin Comment')}</Form.Label>
                      <Form.Control
                        defaultValue={this.state.task_desc1}
                        onChange={(e) =>
                          this.setState({ task_desc1: e.target.value })
                        }
                        as='textarea'
                        rows={3}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={12} className='mb-3'>
                    <CKEditor
                      data={this.state.task_desc2}
                      config={{
                        ckfinder: {
                          uploadUrl: apiURL + '/authentication/ckeditor-upload?auth_key=' + auth_key + '&center_id=' + this.props.authData.centerData.center_id,
                        },
                        toolbar: {
                          items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            '|',
                            'fontColor',
                            'fontFamily',
                            '|',
                            'numberedList',
                            'bulletedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'link',
                            'blockQuote',
                            'imageUpload',
                            'insertTable',
                            '|',
                            'undo',
                            'redo',
                          ],
                        },
                        readOnly: true,
                      }}
                      editor={Editor}
                      onBlur={(event, editor) => {
                        // Array.from(editor.ui.componentFactory.names()).map(item => console.log(item));
                        const data = editor.getData();
                        this.setState({
                          task_desc2: data,
                        });
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Attachment 1')}</Form.Label>
                      <Form.Control
                        id='attachment1'
                        onChange={this.taskAttachmentHandler}
                        type='file'
                        accept='image/jpeg,image/gif,image/png,application/pdf'
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Attachment 2')}</Form.Label>
                      <Form.Control
                        id='attachment2'
                        onChange={this.taskAttachmentHandler}
                        type='file'
                        accept='image/jpeg,image/gif,image/png,application/pdf'
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className='mb-3'>
                      <Form.Label>{t('Attachment 3')}</Form.Label>
                      <Form.Control
                        id='attachment3'
                        onChange={this.taskAttachmentHandler}
                        type='file'
                        accept='image/jpeg,image/gif,image/png,application/pdf'
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  disabled={this.state.working}
                  variant='success'
                  onClick={() => this.saveWaitingTask()}>
                  {t('Add Task')}{' '}
                  {this.state.working ? (
                    <Spinner
                      as='span'
                      animation='grow'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    />
                  ) : (
                    ''
                  )}
                </Button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* Delete Confirmation */}
        <SweetAlert show={this.state.deleteConfirm.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.deleteConfirm.action} onCancel={() => this.setState({ deleteConfirm: { show: false, id: 0, action: () => { } } })} focusCancelBtn>
          {t('Confirm Delete!')}
        </SweetAlert>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(LeadTasks);
